/* ------------------------------------------------------------------
   MIMÍ — difese silenziose sul modulo di iscrizione alla newsletter.
   A video il modulo resta quello di prima: qui lavorano soltanto
   controlli che una persona vera attraversa senza accorgersene.

   1. Campo trappola: un automatismo lo compila, una persona lo salta.
      Se risulta compilato, l'invio si ferma in silenzio.
   2. Controllo del tempo: un invio troppo rapido viene fermato, MA la
      persona lo viene a sapere. Prima il blocco era muto: chi compilava
      in fretta premeva Iscriviti e non succedeva niente, senza capire
      perche'. L'attesa e' scesa da tre secondi a 1,2: la trappola e' la
      difesa vera, questa e' solo una rete di sicurezza.
   3. Data di nascita FACOLTATIVA: se e' vuota si prosegue; se c'e', si
      accetta in formato tollerante e si conserva sul cliente come tag
      nato-AAAA-MM-GG.

   I MESSAGGI non stanno qui dentro: arrivano tradotti dagli attributi
   data-mimi-* che snippets/mimi-esca.liquid stampa nella pagina.
   ------------------------------------------------------------------ */

(function () {
  if (window.mimiIscrizioneAttiva) return;
  window.mimiIscrizioneAttiva = true;

  var ATTESA_MINIMA = 1200;
  var GIORNI_MESE = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  function duecifre(numero) {
    return ('0' + numero).slice(-2);
  }

  function bisestile(anno) {
    return anno % 4 === 0 && (anno % 100 !== 0 || anno % 400 === 0);
  }

  function normalizzaData(valore) {
    var testo = (valore || '').trim();
    if (testo === '') return null;

    var parti = testo.split(/[^0-9]+/).filter(function (pezzo) {
      return pezzo.length > 0;
    });

    var giorno;
    var mese;
    var anno;

    if (parti.length === 1 && parti[0].length === 8) {
      giorno = parseInt(parti[0].slice(0, 2), 10);
      mese = parseInt(parti[0].slice(2, 4), 10);
      anno = parseInt(parti[0].slice(4, 8), 10);
    } else if (parti.length >= 3) {
      giorno = parseInt(parti[0], 10);
      mese = parseInt(parti[1], 10);
      anno = parseInt(parti[2], 10);
    } else {
      return null;
    }

    if (isNaN(giorno) || isNaN(mese) || isNaN(anno)) return null;
    if (mese < 1 || mese > 12) return null;

    var limite = GIORNI_MESE[mese - 1];
    if (mese === 2 && bisestile(anno) === false) limite = 28;
    if (giorno < 1 || giorno > limite) return null;

    var corrente = new Date().getFullYear();
    if (anno < 1900 || anno > corrente) return null;

    return anno + '-' + duecifre(mese) + '-' + duecifre(giorno);
  }

  // Dice le cose invece di tacerle: il messaggio compare sul campo, con il
  // fumetto del browser, che i lettori di schermo annunciano.
  function avvisa(campo, messaggio) {
    if (!campo || !messaggio) return;
    campo.setCustomValidity(messaggio);
    if (campo.reportValidity) campo.reportValidity();
    campo.setCustomValidity('');
  }

  function collega(esca) {
    var modulo = esca.closest('form');
    if (!modulo || modulo.getAttribute('data-mimi-pronto') === '1') return;
    modulo.setAttribute('data-mimi-pronto', '1');

    var campoEsca = esca.querySelector('input');
    var nascita = modulo.querySelector('input[name="mimi_data_nascita"]');
    var posta = modulo.querySelector('input[type="email"]');
    var tag = modulo.querySelector('input[name="contact[tags]"]');
    var tagBase = tag ? tag.value : 'newsletter';

    var testoErroreData = esca.getAttribute('data-mimi-errore-data') || '';
    var testoAttendi = esca.getAttribute('data-mimi-attendi') || '';

    var primoTocco = 0;
    var segnaTocco = function () {
      if (primoTocco === 0) primoTocco = Date.now();
    };

    modulo.addEventListener('focusin', segnaTocco, true);
    modulo.addEventListener('input', segnaTocco, true);
    modulo.addEventListener('pointerdown', segnaTocco, true);

    if (nascita) {
      nascita.addEventListener('input', function () {
        nascita.setCustomValidity('');
      });
    }

    modulo.addEventListener('submit', function (evento) {
      if (campoEsca && campoEsca.value.trim() !== '') {
        evento.preventDefault();
        return;
      }

      if (primoTocco === 0 || Date.now() - primoTocco < ATTESA_MINIMA) {
        evento.preventDefault();
        primoTocco = Date.now() - ATTESA_MINIMA + 300;
        avvisa(posta || nascita, testoAttendi);
        return;
      }

      // La data di nascita e' facoltativa: vuota, si prosegue senza tag.
      if (nascita && nascita.value.trim() !== '') {
        var data = normalizzaData(nascita.value);

        if (data === null) {
          evento.preventDefault();
          avvisa(nascita, testoErroreData);
          return;
        }

        nascita.setCustomValidity('');
        if (tag) tag.value = tagBase + ', nato-' + data;
      }
    });
  }

  function avvia() {
    var esche = document.querySelectorAll('.mimi-esca');
    Array.prototype.forEach.call(esche, collega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  document.addEventListener('shopify:section:load', avvia);
})();
